const initialState = {
  loginPending: false,
  loginError: null,
  user: {
    username: null,
    password: null,
    isLoggedIn: false,
  },
  fetchStatisticsPending: false,
  fetchStatisticsError: null,
  statistics: {
    exerciseStatistics: [],
    loginStatisticsStatistics: [],
  },
  products: [],
  licenses: [],
  fetchLoginStatisticsPending: false,
  fetchLoginStatisticsError: null,
  fetchLicensesPending: false,
  fetchLicensesError: null,
  getProductsPending: false,
  getProductsError: null,
  getCustomersPending: false,
  getCustomersError: null,
  getLoginTimesPending: false,
  getLoginTimesError: null,
  getExerciseStatisticsPending: false,
  getExerciseStatisticsError: null,
  isApplicationReady: false,
};

export default initialState;



// WEBPACK FOOTER //
// ./src/features/home/redux/initialState.js